import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import UserDashboard from './pages/user-dashboard';
import AuthenticationPortal from './pages/authentication-portal';
import HomeLandingPage from './pages/home-landing-page';
import CourseCatalog from './pages/course-catalog';
import VideoLearningInterface from './pages/video-learning-interface';
import InstitutionsSignup from './pages/institutions-signup';
import ForIndividuals from './pages/for-individuals';
import OrganizationOnboarding from './pages/organization-onboarding';
import OrganizationDashboard from './pages/organization-dashboard';
import OrganizationCourseBuilder from './pages/organization-course-builder';
import OrganizationProgramBuilder from './pages/organization-program-builder';
import OrganizationCohortWorkspace from './pages/organization-cohort-workspace';
import LiveClassroomHost from './pages/live-classroom-host';
import LiveClassroomViewer from './pages/live-classroom-viewer';
import MentorWorkspace from './pages/mentor-workspace';
import MenteeWorkspace from './pages/mentee-workspace';
import CoursePreview from './pages/course-preview';
import CourseCapstone from './pages/course-capstone';
import CertificateVerify from './pages/certificate-verify';
import VisioneerPage from './pages/visioneer';
import BlogPage from './pages/blog';
import BlogPreview from './pages/blog/preview';
import BlogArticle from './pages/blog/article';
import BlogComposer from './pages/blog-composer';
import PostManager from './pages/blog-admin';
import ControlPlane from './pages/control-plane';
import PublicProfile from './pages/public-profile';
import SearchPage from './pages/search';
import ComingSoon from './pages/coming-soon';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<AuthenticationPortal />} />
        <Route path="/user-dashboard" element={<UserDashboard />} />
        <Route path="/authentication-portal" element={<AuthenticationPortal />} />
        <Route path="/home-landing-page" element={<HomeLandingPage />} />
        <Route path="/course-catalog" element={<CourseCatalog />} />
        <Route path="/video-learning-interface" element={<VideoLearningInterface />} />
        <Route path="/for-institutions" element={<InstitutionsSignup />} />
        <Route path="/for-individuals" element={<ForIndividuals />} />
        <Route path="/organization-onboarding" element={<OrganizationOnboarding />} />
        <Route path="/organization-dashboard" element={<OrganizationDashboard />} />
        <Route path="/organization-course-builder" element={<OrganizationCourseBuilder />} />
        <Route path="/organization-program-builder" element={<OrganizationProgramBuilder />} />
        <Route path="/organization-cohort-workspace" element={<OrganizationCohortWorkspace />} />
        <Route path="/live-classroom-host" element={<LiveClassroomHost />} />
        <Route path="/live-classroom-viewer" element={<LiveClassroomViewer />} />
        <Route path="/mentor-workspace" element={<MentorWorkspace />} />
        <Route path="/mentee-workspace" element={<MenteeWorkspace />} />
        <Route path="/course-preview" element={<CoursePreview />} />
        <Route path="/course-capstone" element={<CourseCapstone />} />
        <Route path="/verify/:certId" element={<CertificateVerify />} />
        <Route path="/id/:nesolearnId" element={<PublicProfile />} />
        <Route path="/visioneer" element={<VisioneerPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogArticle />} />
        <Route path="/blog/preview/:postId" element={<BlogPreview />} />
        <Route path="/blog-composer" element={<BlogComposer />} />
        <Route path="/blog-admin" element={<PostManager />} />
        <Route path="/control-plane" element={<ControlPlane />} />
        <Route path="/earn" element={<ComingSoon label="Earn on Nesolearn" />} />
        <Route path="/nesolearn-kids" element={<ComingSoon label="Nesolearn Kids" />} />
        <Route path="/for-teams" element={<ComingSoon label="For Teams" />} />
        <Route path="/for-enterprises" element={<ComingSoon label="For Enterprises" />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
